var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    id: "logo",
    className: "logo eyeson-logo",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "eyeson logo") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8,
    cy: 19.8,
    fill: "#000",
    r: 19.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 4.3c-8.6 0-15.5 7-15.5 15.5 0 8.6 7 15.5 15.5 15.5 8.6 0 15.5-6.9 15.5-15.5.1-8.5-6.9-15.5-15.5-15.5zm0 26.7c-6.1 0-11.1-4.9-11.1-11 0-3.2 1.4-6.3 3.8-8.5-.4.7-.5 1.6-.3 2.4.6 2.1 3.4 3 6.1 2.2s4.4-3.2 3.8-5.3c-.4-1.1-1.2-1.9-2.3-2.2 6.1 0 11.1 5 11.1 11.1C31 26 26 31 19.8 31z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.54cc93755fa6df7a1e95cdb3c26d3041.svg";
export { ForwardRef as ReactComponent };